import { translate } from '@teamleader/i18n';
import { IconCloseMediumOutline } from '@teamleader/ui-icons';
import cx from 'classnames';
import React from 'react';

import Footer from './Footer';
import styles from './styles.css';
import Box, { BoxProps } from '../Box';
import IconButton from '../IconButton';

export enum SIZES {
  REGULAR,
  WIDER,
  WIDEST,
}

interface SubComponents {
  Footer: typeof Footer;
}

interface SidebarProps extends BoxProps {
  onClose?: () => void;
  size?: SIZES;
}

const Sidebar: React.FC<SidebarProps> & SubComponents = ({ onClose, className, children, size, ...rest }) => {
  return (
    <Box
      element="aside"
      className={cx(
        styles['sidebar'],
        {
          [styles['sidebar--wider']]: size === SIZES.WIDER,
          [styles['sidebar--widest']]: size === SIZES.WIDEST,
          [styles['sidebar--no-close-button']]: !onClose,
        },
        className,
      )}
      display="flex"
      flexDirection="column"
      {...rest}
    >
      {onClose && (
        <IconButton
          className={styles['close-button']}
          icon={<IconCloseMediumOutline />}
          onClick={onClose}
          title={translate('actions.close')}
        />
      )}
      {children}
    </Box>
  );
};

Sidebar.Footer = Footer;
export default Sidebar;
